import React, { FC } from "react";
import { SxProps, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useAtom } from "jotai";
import {
    notificationPopoverAtom,
    setShowOnlyUnreadNotifications,
} from "../../stores/jotai/notification/notificationPopover";
import { NOTIFICATION_UNREAD_SWITCH_VALUES } from "../../constants";
import { useTheme,Theme } from '@mui/material/styles';

interface INotificationUnreadFilterSwitchProps {
    sx: SxProps;
}

const ToggleButtonGroupStyles = (theme: Theme)=> ({
    backgroundColor: theme?.custom?.disabledColor,
    borderRadius: "4px",
    height: "36px",
    "& .MuiToggleButtonGroup-grouped": {
        margin: "3px",
        border: 0,
        padding: "0 8px",
        textTransform: "capitalize",
        fontSize: "13px",
        ":hover": {
            backgroundColor: "rgba(255,255,255,0.4)",
        },
        "&.Mui-selected": {
            color: theme?.custom?.mainButtonHighlight,
            "&, :hover": {
                backgroundColor: theme?.custom?.white,
            },
        },
        "&.Mui-disabled": {
            border: 0,
        },
        "&:not(:first-of-type)": {
            borderRadius: "4px",
            marginLeft: "2px",
        },
        "&:first-of-type": {
            borderRadius: "4px",
            marginRight: "2px",
        },
    },
});

const NotificationUnreadFilterSwitch: FC<INotificationUnreadFilterSwitchProps> = (props) => {
    const { sx } = props;
    const [notificaitonPopoverAtomState, setNotificaitonPopoverAtomState] =
        useAtom(notificationPopoverAtom);
    const { showOnlyUnreadNotifications } = notificaitonPopoverAtomState;
    const theme = useTheme();
    const handleUnreadFilterChange = (
        event: React.MouseEvent<HTMLElement>,
        filterState: boolean
    ) => {
        if (filterState !== null) {
            setShowOnlyUnreadNotifications(
                setNotificaitonPopoverAtomState,
                filterState
            );
        }
    };

    return (
        <ToggleButtonGroup
            size="small"
            onChange={handleUnreadFilterChange}
            value={showOnlyUnreadNotifications}
            exclusive={true}
            sx={{
                ...ToggleButtonGroupStyles(theme),
                ...sx,
            }}
        >
            <ToggleButton value={true}>
                {NOTIFICATION_UNREAD_SWITCH_VALUES.UNREAD}
            </ToggleButton>
            <ToggleButton value={false}>
                {NOTIFICATION_UNREAD_SWITCH_VALUES.ALL}
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

NotificationUnreadFilterSwitch.defaultProps = {
    sx: {},
}

export default NotificationUnreadFilterSwitch;
